import React from "react";
import { motion } from "framer-motion";
import cn from "classnames";
import cls from "./styles.module.scss";

export type ButtonVariant =
  | "primary"
  | "text"
  | "outlined"
  | "iconOnly"
  | "danger"
  | "orange"
  | "tg";

interface ButtonProps {
  label?: string;
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  loading?: boolean;
  type?: "button" | "submit" | "reset";
  variant?: ButtonVariant;
  icon?: React.ReactNode;
  iconCls?: string;
  stopPropagation?: boolean;
  className?: string;
}

const Button: React.FC<ButtonProps> = ({
  label,
  onClick,
  disabled = false,
  loading = false,
  type = "button",
  variant = "primary",
  icon,
  iconCls,
  stopPropagation,
  className = "",
}) => {
  const isDisabled = disabled || loading;
  const variantClass = cls[variant];

  const click = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (stopPropagation) e.stopPropagation();
    onClick(e);
  };

  return (
    <motion.button
      type={type}
      className={cn(
        cls.button,
        variantClass,
        { [cls.disabled]: isDisabled },
        className
      )}
      onClick={click}
      disabled={isDisabled}
      whileHover={!isDisabled ? { scale: 1.02 } : {}}
      whileTap={!isDisabled ? { scale: 0.98 } : {}}
    >
      {loading ? (
        <div className={cls.spinner} aria-label="Loading" />
      ) : (
        <>
          {variant === "iconOnly"
            ? icon
            : icon && <div className={cn(cls.icon, iconCls)}>{icon}</div>}
          {variant !== "iconOnly" && label && <div>{label}</div>}
        </>
      )}
    </motion.button>
  );
};

export default Button;
